import { InjectionToken } from '@angular/core';
import { type LoggerConfig } from './logger.config';

export const LOGGER_CONFIG = new InjectionToken<Partial<LoggerConfig>>('LOGGER_CONFIG');
